export const LOCALSTORAGE_KEY = 'giftbox-tracking';
